import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from "@tanstack/react-query";

import { useServer } from "../../server/ServerContext";
import { PortalAxiosError } from "../../types";
import { PreferencesData } from "./types";
import { preferencesKeys } from "./utils";

export const useUpdatePreferences = (
  key: string,
  options?: UseMutationOptions<PreferencesData, PortalAxiosError, boolean>
) => {
  const server = useServer();
  const queryClient = useQueryClient();

  return useMutation<PreferencesData, PortalAxiosError, boolean>(
    (enabled) => server.put("preferences", { [key]: enabled }),
    {
      onMutate: (enabled: boolean) => {
        const previousPreferences = queryClient.getQueryData<PreferencesData>(
          preferencesKeys.list
        );

        if (previousPreferences) {
          queryClient.setQueryData<PreferencesData>(preferencesKeys.list, {
            data: {
              ...previousPreferences.data,
              [key]: enabled,
            },
          });
        }

        return previousPreferences;
      },
      onError: (error, value, previousPreferences) => {
        queryClient.setQueryData(preferencesKeys.list, previousPreferences);
        options?.onError?.(error, value, previousPreferences);
      },
      ...options,
    }
  );
};

export default useUpdatePreferences;
